import { LocaleTypes } from "@iddataweb/idw-common-ui/enums";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import styles from "./message-template-preview-container.less";
import { MessageTemplateContentPreview } from "@containers/message-template-details/message-template-details-component/message-template-preview-container/message-template-content-preview/message-template-content-preview";

type MessageTemplatePreviewContainerProps = {
    state: FormattedMessageTemplate;
    selectedLanguage: LocaleTypes;
};

export const MessageTemplatePreviewContainer = (props: MessageTemplatePreviewContainerProps) => {
    const {
        state,
        selectedLanguage
    } = props;

   

    return (
        <div className={styles.messageTemplatePreviewContainer}>
            <div className={styles.contentPreviewHeader}>Preview</div>
           <MessageTemplateContentPreview state={state} selectedLanguage={selectedLanguage}  />
        </div>
    );
};